export enum GeofenceType {
  circle = 'circle',
  polygon = 'polygon',
}
